import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const saveNoShowAppointmentSkippedApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    saveNoShowAppointmentSkipped: builder.mutation({
      query: ({ body, preferredLanguage }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = preferredLanguage;
        return {
          url: `/api/v1/Appointment/noshow-appointment-skipped`,
          method: "POST",
          data: body,
          headers,
        };
      },
      invalidatesTags: (result, error) => [{ type: "NoShowAppointment" }],
    }),
  }),
  overrideExisting: false,
});

export const { useSaveNoShowAppointmentSkippedMutation } =
  saveNoShowAppointmentSkippedApi;
export default saveNoShowAppointmentSkippedApi;
